import React, { useCallback, useEffect, useState } from 'react';
import { useGlobalContext } from '../../../context/GlobalContext';
import {
  getDashboardActivityAction,
  getOptionsListsAction,
  getStudiesListsAction
} from '../../../actions/studiesActions';

import NewsTile from './tiles/NewsTile';
import CompetitorsTile from './tiles/CompetitorsTile';
import StudiesTimelineTile from './tiles/StudiesTimelineTile';
import styles from './Dashboard.module.scss';

export default function DashboardPage({ setActivePage }) {
  const [context, dispatch] = useGlobalContext();
  const { studiesList, optionsLists } = context.studies;
  const [activity, setActivity] = useState([]);
  const [isTimelineExpanded, setIsTimelineExpanded] = useState(false);

  const initData = useCallback(() => {
    setActivePage('dashboard');
    getStudiesListsAction(dispatch);
    getOptionsListsAction(dispatch);
    getDashboardActivityAction(dispatch).then((items) => setActivity(items || []));
  }, [dispatch, setActivePage]);

  useEffect(() => {
    initData();
  }, [initData]);

  return (
    <div className={`page-container ${styles.dashboard} ${isTimelineExpanded ? styles.dashboardExpanded : ''}`}>
      <div className={`${styles.grid} ${isTimelineExpanded ? styles.gridTimelineExpanded : ''}`}>
        {!isTimelineExpanded && (
          <>
            <NewsTile activity={activity} />
            <CompetitorsTile
              studies={studiesList || []}
              companies={optionsLists?.companies || []}
            />
          </>
        )}

        <StudiesTimelineTile
          studies={studiesList || []}
          optionsLists={optionsLists}
          isExpanded={isTimelineExpanded}
          onToggleExpand={() => setIsTimelineExpanded(value => !value)}
        />
      </div>
    </div>
  );
}
